export default __webpack_public_path__ + "static/media/excle_log.400fecc7.png";